import { useMemo } from "react";
import { useTable, useFilters, useGlobalFilter, useRowSelect, usePagination } from "react-table";
import DefaultColumnFilter from "./SD_einsehen/TabellenBausteine";

export default function GeneralTable ({columns, data, hiddenColumns, additionalColumns, reloadData}) {
    const defaultColumn = useMemo(() => ({
        Filter: DefaultColumnFilter
    }),[])

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page, // Instead of using 'rows', we'll use page,
            // which has only the rows for the active page

        // The rest of these things are super handy, too ;)
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize },
      } = useTable(
        {
          columns,
          data,
          reloadData,
          defaultColumn, // Be sure to pass the defaultColumn option
          initialState: {
              hiddenColumns: hiddenColumns,
              pageIndex: 0,
              pageSize: 25,
          }
        },
        useFilters, // useFilters!
        useGlobalFilter, // useGlobalFilter!
        usePagination,
        useRowSelect,
        hooks => {
            hooks.visibleColumns.push(columns => [
                ...columns,
                ...additionalColumns
            ])
        }
      )

    //   Festlegung wie viele Zeilen gezeigt werden sollen: nur wenn keine Pagination!
    // const rowsPerPage = rows.slice(0, 10);

    return (
        <div >
        <table {...getTableProps()} className="general-table">
            <thead>
                {headerGroups.map((headerGroup, hgIndex) => (
                    //key={`headergroup-${hgIndex}`}
                    // key={`${column.render('Header')}`}
                    // key={`${i}-${cell.render('Header')}`}
                    <tr {...headerGroup.getHeaderGroupProps()} key={`headergroup-${hgIndex}`} > 
                        {headerGroup.headers.filter(column => !column.unused).map((column, colIndex) => (
                            <th {...column.getHeaderProps()} key={`${column.render('Header')}-${colIndex}`} style={{border: "1px solid whitesmoke", width: `${columns.filter(col => col.Header === column.render('Header')).map(c => c.width)}`}}>
                                {column.render('Header')}
                                <div>
                                    {column.canFilter ? column.render('Filter') : null}
                                </div>
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()} className="general-table-body" key="body">
                {page.map((row, i) => {
                    prepareRow(row)
                    return (
                        <tr {...row.getRowProps()} key={i} className={i % 2 === 0 ? "even-page" : "odd-page"}>
                            {row.cells.filter(cell => !cell.render('Cell').props.column.unused).map(cell => {
                                return <td {...cell.getCellProps()} 
                                key={cell.render('Header') !== "" ? `${i}-${cell.render('Header')}` : `${i}-${cell.render('keyword')}`}
                                 className="general-table-cell" style={{width: `${columns.filter(col => col.Header === cell.render('Header')).map(c => c.width)}`, height: '1.5em'}}>
                                            {cell.render('Cell')} </td>
                                }
                            )}
                        </tr>
                    )
                })}
            </tbody>
        </table>
        {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
        <div className="pagination">
            <select
                value={pageSize}
                onChange={e => {
                setPageSize(Number(e.target.value))
                }}
            >
                {[25, 50, 100].map(pageSize => (
                <option key={pageSize} value={pageSize}>
                    Zeige {pageSize}
                </option>
                ))}
            </select>

            <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                {'<<'}
            </button>

            <button onClick={() => previousPage()} disabled={!canPreviousPage}>
                {'<'}
            </button>

            <button onClick={() => nextPage()} disabled={!canNextPage}>
                {'>'}
            </button>

            <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                {'>>'}
            </button>

            <span >
                Seite
                <span>
                {pageIndex + 1} von {pageOptions.length}
                </span>
            </span>
        {/* <span>
            | Gehe zu Seite:{' '}
            <input
            type = "number"
            min = "1"
            max = {pageCount}
            defaultValue={pageIndex + 1}
            onChange={e => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0
                gotoPage(page)
            }}
            style={{ width: '100px' }}
            />
        </span>{' '} */}
        </div>
        </div>
    )    
}
